import script from "./CategoryAttributePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryAttributePage.vue?vue&type=script&setup=true&lang=js"

import "./CategoryAttributePage.vue?vue&type=style&index=0&id=55da7ae9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55da7ae9"]])

export default __exports__